<template>
  <footer class="main-footer">
    <!-- <div class="float-right d-none d-sm-block">
      <b>Version</b>1.0
    </div>  -->
    <strong class="d-md-inline aviso a_copy"><span class="copu">Copyright &copy; 2024  Grupo Horizon.</span></strong> 
    <span class="aviso" @click="sbDescargarTerminos()">Terminos y Condiciones</span>
    <span class="aviso" @click="sbModalCentro()">Centros de Canje</span>

    <b-modal size="md" title="Centros de Canje" 
      v-model="modalCentro" hide-footer centered
      dialog-class="contenedor_canjear"
      header-class="contenido_cabecera"
      content-class="contenido_modal"
    >
      <template #modal-title>
        <div class="header_modal">
          <i class="fa-solid fa-location-dot"></i>
          <span>Centros de Canje</span>
        </div>
      </template>

      <b-container> 
        <gMaps></gMaps>
      </b-container>
    </b-modal>

  </footer>

</template>

<script>
import servicioCliente from '../services/servicioCliente'
import gMaps from '../components/maps.vue'
export default {
  components: { gMaps },
  data() {
    return {
      modalCentro:false
    }
  },
  methods:
  {
    async sbDescargarTerminos() {
      try {
        const data = await servicioCliente.descargarTerminos()
        var pdde = data
        var byteCharacters = atob(pdde);
        var byteNumbers = new Array(byteCharacters.length);
        
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        var file = new Blob([byteArray], { type: 'application/pdf;base64' });
        var fileURL = URL.createObjectURL(file);

        window.open(fileURL); 

      } catch (error) {
        console.log(error);
      }
    },
        
    sbModalCentro() {
      this.modalCentro= true;
    }
  }
}
</script>

<style scope>
.aviso.a_copy,
.aviso.a_copy:hover{
  color: #6E6E6E;
  cursor: auto;
}

.aviso {
  font-size: 12px;
  color: #0073BC;
  font-weight:600;
}

.aviso:hover
{
  cursor: pointer;
  color: #002C47;
}

@media (max-width: 650px) {
  .main-footer{
    justify-content: space-around !important;
    gap: 5px !important;
  }

  .aviso {
    font-size: 10px;
  }
}
</style>